var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Icon, Select, Table } from 'semantic-ui-react';
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { priceColumn, PriceDisplay } from "../rna-fish/EditKitForm";
var ManualProConsumerAmpForm = /** @class */ (function (_super) {
    __extends(ManualProConsumerAmpForm, _super);
    function ManualProConsumerAmpForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayChromogenNote = function () {
            return _this.props.ampState.chromogen.id === 'MATISSE_GREEN';
        };
        _this.priceDisplay = function () {
            return React.createElement(PriceDisplay, { priceCents: _this.props.priceCents, loading: _this.props.priceLoading });
        };
        _this.onChromogenChange = function (_, data) {
            var valStr = data.value;
            var chromogen = _this.props.catalog.cishChromogens.chromogens
                .concat([{ id: 'NONE', label: 'NONE', protocolCompatibility: [], enzymeCompatibility: '', bufferCompatibility: { id: 'NONE', label: 'NONE' } }])
                .find(function (c) { return c.id === valStr; });
            if (chromogen === undefined) {
                throw new RangeError("Invalid  chromogen " + valStr);
            }
            _this.props.onAmpStateChange({
                chromogen: chromogen
            }, _this.props.onUserSelection);
        };
        _this.onScaleChange = function (_, data) {
            var v = data.value;
            var newScale = _this.currentScales().find(function (s) { return s === v; });
            if (newScale === undefined) {
                throw new RangeError("Unknown scale value " + v);
            }
            _this.props.onAmpStateChange({
                scale: newScale
            }, _this.props.onUserSelection);
        };
        _this.currentScales = function () {
            var _a;
            var scales = (_a = _this.props.catalog.manualProAmpCatalog) === null || _a === void 0 ? void 0 : _a.amplifierScales;
            if (scales === undefined) {
                throw new RangeError("Invalid scales");
            }
            // don't mess with the arrays in the catalog
            scales = Array.from(scales);
            scales.sort(function (s1, s2) { return s1 - s2; });
            return scales;
        };
        _this.checkChromogenCompatibility = function (chromogen, enzyme) {
            if (chromogen == null || enzyme == null) {
                return false;
            }
            else {
                return chromogen.protocolCompatibility.some(function (p) { return p.id === enzyme.protocolType.id; }) &&
                    (enzyme.displayName === "HRP & AP" || enzyme.displayName === chromogen.enzymeCompatibility);
            }
        };
        return _this;
    }
    ManualProConsumerAmpForm.prototype.render = function () {
        var _this = this;
        var amplifierLabel = React.createElement(React.Fragment, null,
            "Amplifier ",
            React.createElement(Help, null,
                React.createElement("p", null, "HCR\u2122 Pro RNA-ISH kits use an X2-system HCR\u2122 Pro Amplifier in combination with an X2-system HCR\u2122 HiFi Probe."),
                React.createElement("p", { style: { marginBottom: 5 } }, "HCR\u2122 Pro Amplifier kit includes:"),
                React.createElement("ul", { style: { paddingLeft: 35, marginTop: 5 } },
                    React.createElement("li", null, "Pretreat"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect A"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect B"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect C"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect D"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect E"),
                    React.createElement("li", null, "HCR\u2122 Pro Detect F HRP"),
                    React.createElement("li", null, "Post-Process")),
                React.createElement("p", { style: { marginBottom: 5 } }, "A complimentary Matisse\u00AE chromogen kit is also provided, which includes:"),
                React.createElement("ul", { style: { paddingLeft: 35, marginTop: 5 } },
                    React.createElement("li", null, "Matisse\u00AE Green or Matisse\u00AE Brown"),
                    React.createElement("li", null, "Matisse\u00AE Green Buffer or Matisse\u00AE Brown Buffer"))));
        var enzymeLabel = React.createElement(React.Fragment, null,
            "Enzyme ",
            React.createElement(Help, null, "HCR\u2122 Pro RNA-ISH kits integrate enzymatic signal amplification using horseradish peroxidase (HRP)."));
        var scaleLabel = React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The HCR\u2122 Pro Amplifier kit is available at either small or large scales. For different sample types, representative reaction volumes and number of experiments are:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "Small Scale"),
                            React.createElement(Table.HeaderCell, null, "Large Scale"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "10"),
                            React.createElement(Table.Cell, null, "50")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo)"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "2"),
                            React.createElement(Table.Cell, null, "10"))))));
        var chromogenLabel = React.createElement(React.Fragment, null,
            "Chromogen Kit ",
            React.createElement(Help, null,
                React.createElement("p", null,
                    "Use your HCR\u2122 Pro RNA-ISH kit with an HRP chromogen for RNA-CISH (e.g., a complimentary Matisse\u00AE chromogen optimized for use with HCR\u2122 Pro) or an HRP fluorogenic substrate for RNA-FISH (e.g., any of a variety of recommended third-party fluorescent tyramides; see table in ",
                    React.createElement("a", { href: "https://files.molecularinstruments.com/HCR\u2122-Pro-RNAISH-User-Guide.pdf" }, "HCR\u2122 Pro RNA-ISH User Guide"),
                    ")."),
                React.createElement("p", { style: { marginBottom: 5 } }, "Complimentary Matisse\u00AE chromogen kit includes:"),
                React.createElement("ul", { style: { paddingLeft: 35, marginTop: 5 } },
                    React.createElement("li", null, "Matisse\u00AE Green or Matisse\u00AE Brown"),
                    React.createElement("li", null, "Matisse\u00AE Green Buffer or Matisse\u00AE Brown Buffer"))));
        var scaleOptions = !this.props.ampState.scale ?
            [{
                    text: '10 samples',
                    content: '10 samples',
                    value: -1
                }] :
            this.currentScales().map(function (s) {
                var numberOfTubes = calculateNumOfTubesForAmp(s);
                if (_this.props.selectedSampleType.id === 'WHOLE_MOUNT' || _this.props.selectedSampleType.id === 'CELLS_SUSPENSION') {
                    return {
                        text: React.createElement(React.Fragment, null,
                            numberOfTubes,
                            " tubes"),
                        content: React.createElement(React.Fragment, null,
                            numberOfTubes,
                            " tubes"),
                        value: s
                    };
                }
                else if (_this.props.selectedSampleType.id === 'TISSUE_SECTION' || _this.props.selectedSampleType.id === 'CELLS_SLIDE') {
                    return {
                        text: React.createElement(React.Fragment, null,
                            s,
                            " slides"),
                        content: React.createElement(React.Fragment, null,
                            s,
                            " slides"),
                        value: s
                    };
                }
                else {
                    return {
                        text: '',
                        content: null,
                        value: s
                    };
                }
            });
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/hcrAmplifier', errors: this.props.errors, labelContent: amplifierLabel, labelFor: 'amp-hcr-amplifier', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "label-dropdown", disabled: true, value: this.props.ampState.hcrAmplifier.id, options: this.props.catalog.manualProAmpCatalog.amplifierConfig
                                .map(function (c) {
                                return {
                                    text: c.amplifier.id,
                                    value: c.amplifier.id
                                };
                            }), name: 'amp-hcr-amplifier' }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/enzyme', errors: this.props.errors, labelContent: enzymeLabel, labelFor: 'amp-enzyme', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-enzyme', className: "deactivated-dropdown", options: this.props.catalog.manualProAmpCatalog.amplifierConfig
                                .map(function (c) {
                                return {
                                    text: c.displayName,
                                    value: c.id
                                };
                            }), value: this.props.ampState.enzyme.id, disabled: true }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/scalePmol', errors: this.props.errors, labelContent: scaleLabel, labelFor: 'amp-scale', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-scale', className: this.props.ampState.scale ? "label-dropdown" : "deactivated-dropdown", value: this.props.ampState.scale ? this.props.ampState.scale : -1, disabled: !this.props.ampState.scale, onChange: this.onScaleChange, options: scaleOptions })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/chromogen', errors: this.props.errors, labelContent: chromogenLabel, labelFor: 'chromogen', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'chromogen', className: "label-dropdown", value: this.props.ampState.chromogen.id, onChange: this.onChromogenChange, options: this.props.catalog.cishChromogens.chromogens.filter(function (c) { return _this.checkChromogenCompatibility(c, _this.props.ampState.enzyme); }).map(function (c) {
                                return {
                                    text: c.label,
                                    value: c.id
                                };
                            }).concat([{ text: 'None', value: 'NONE' }]) }))),
                this.displayChromogenNote() ?
                    React.createElement(Grid.Column, { style: { 'marginTop': '25px' } },
                        React.createElement(Icon, { style: { 'color': '#333333' }, name: 'lightbulb outline' }),
                        React.createElement("em", { style: { 'color': '#333333' } }, "Matisse\u00AE Brown is optimal for combining HCR\u2122 Pro RNA-CISH with traditional IHC assays.")) :
                    React.createElement(Grid.Column, null),
                React.createElement(Grid.Column, null),
                priceColumn(this.priceDisplay())));
    };
    return ManualProConsumerAmpForm;
}(React.PureComponent));
export { ManualProConsumerAmpForm };
export var calculateNumOfTubesForAmp = function (scale) {
    return Math.round(scale / 5);
};
//# sourceMappingURL=ManualProConsumerAmpForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/bundle-of-kits/ManualProConsumerAmpForm.js
// module id = 1084
// module chunks = 0